<div
  class="footer-container"
  #footerContainer
  [ngClass]="menu | productMenuBasicMethod: 'getFooterWrapperClass'"
  [style.color]="menu?.hydratedTheme?.themeFeatures?.footerTextColor ? menu?.menuOptions?.footerTextColor : ''">
  <div class="classification-container">
    <div *ngFor="let classification of menuClassifications$ | async" class="classification-mapping">
      <div class="classification-badge" [ngClass]="classification | lowercase">
        {{ classification | getClassificationSymbol }}
      </div>
      <span class="classification-name"> = {{ classification | uppercase }} </span>
    </div>
  </div>
  <div class="footer-badge-container">
    <div
      *ngFor="
        let badge of menuBadges$ | async | filterList: removePLKeywordBadges;
        trackBy: trackByBadgeUniqueIdentifier
      "
      class="badge-container">
      <img appImage class="footer-badge" [asset]="badge?.image" [reset]="reset" alt="badge" src="" />
      <div class="footer-badge-title">= {{ badge?.name | uppercase | replace: '\\[PL\\]' : '' | trimSafely }}</div>
    </div>
  </div>
</div>
